import { LogLevel } from '@azure/msal-browser'
import { settings } from './settings'

export const msalConfig = {
  auth: {
    clientId: settings.MSAL_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${settings.MSAL_TENANT_ID}`,
    redirectUri: settings.DOMAIN_PROTOCOL || '',
    postLogoutRedirectUri: '/login',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            break
          case LogLevel.Info:
            console.info(message)
            break
          case LogLevel.Verbose:
            console.debug(message)
            break
          case LogLevel.Warning:
            console.warn(message)
            break
          default:
            break
        }
      },
    },
  },
}

export const loginRequest = {
  scopes: [],
}
